import { apiClient } from "../common/axiosInstance";
import { handleAxiosError } from "../common/handleAxiosError";

export const getUserInfo = async () => {

  try {
    const response = await apiClient.get("/users/user-info-user");
    return response.data;
  } catch (error) {
    handleAxiosError(error, "Error fetching user info");
  }
};
